export default __webpack_public_path__ + "static/media/americanexpress.9bd71699.png";